/* LUKS — email and phone capture, posted straight to Klaviyo.

   Shopify's {% form 'customer' %} is deliberately NOT used. It is gated by
   hCaptcha, which redirects to /challenge and takes the visitor off the page,
   and it cannot carry a phone number or per-channel SMS consent anyway.

   One request to Klaviyo's Create Client Subscription endpoint handles both
   channels, writes timestamped consent records, and never leaves the page.
   Signups live in Klaviyo, not as Shopify customers. That is the trade: for a
   waitlist, Klaviyo is the list you actually send from.

   Needs a Klaviyo public key and list ID on the section. Public key only — it
   is visible in page source by design and can do nothing but add a
   subscription. */
(function () {
  'use strict';

  var REVISION = '2026-01-15';
  var stacks = document.querySelectorAll('[data-signup]');
  if (!stacks.length || !window.fetch) return;

  /* ---- Ad tracking (v1.1) ------------------------------------------------
     Everything in this block is best-effort. Each piece is wrapped so that a
     failure can never stop a signup reaching Klaviyo.

     1. On landing, UTM tags and fbclid are kept for the session, so they
        survive the visitor scrolling or reloading before signing up.
     2. On signup, they are written to the Klaviyo profile, along with one
        event ID, so every subscriber can be traced back to the ad they
        came from.
     3. Only AFTER Klaviyo confirms, a 'luks_lead' event is published to
        Shopify. The Meta custom pixel (Settings > Customer events) turns it
        into a Lead event using the same ID, so a later server-side copy
        can be deduplicated against it. */
  var TRACK_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid'];

  try {
    var qs = new URLSearchParams(window.location.search);
    TRACK_KEYS.forEach(function (k) {
      var v = qs.get(k);
      if (v) window.sessionStorage.setItem('luks_' + k, v.slice(0, 250));
    });
  } catch (e) { /* storage blocked: tracking skipped, signup unaffected */ }

  function tracked(k) {
    try { return window.sessionStorage.getItem('luks_' + k) || ''; } catch (e) { return ''; }
  }

  /* Older iOS has no crypto.randomUUID, so fall back rather than throw. */
  function newEventId() {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    } catch (e) {}
    return 'lead-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function publishLead(eventId) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('luks_lead', {
          eventId: eventId,
          utm_content: tracked('utm_content')
        });
      }
    } catch (e) { /* pixel side failed: signup already saved */ }
  }
  /* ---- end ad tracking -------------------------------------------------- */

  /* Klaviyo requires E.164. Australians type 0412 345 678. */
  function e164(raw, cc) {
    var v = String(raw || '').replace(/[^\d+]/g, '');
    if (!v) return '';
    cc = (cc || '+61').replace(/[^\d+]/g, '');
    var bare = cc.replace('+', '');
    if (v.charAt(0) === '+') return v;
    if (v.indexOf(bare) === 0 && v.length > 9) return '+' + v;
    if (v.charAt(0) === '0') return cc + v.slice(1);
    return cc + v;
  }

  /* Swap to the confirmed state. Echo the address back so a typo is visible,
     and move focus into the panel — the form is hidden on success, so a
     keyboard user would otherwise be dropped to the top of the document.
     The panel carries role="status", so screen readers announce it too. */
  function confirmed(stack) {
    /* Lock the height before swapping. Both states share a grid cell, but the
       hero column is vertically centred, so any change in the column's total
       height re-centres everything above it — the heading visibly drops.
       Pinning the measured height means nothing on the page moves at all. */
    var h = stack.offsetHeight;
    if (h) stack.style.minHeight = h + 'px';

    stack.dataset.done = 'true';
    var panel = stack.querySelector('[role="status"]');
    if (panel && typeof panel.focus === 'function') panel.focus({ preventScroll: true });
    scrollOn(stack);
  }

  /* After confirming, give them a beat to read it, then carry them into the
     next section. Skipped entirely for reduced-motion users, and cancelled the
     moment they scroll themselves — hijacking someone who is already moving is
     worse than not scrolling at all. */
  /* Length of the confirm animation in luks-shopify.css: the last line starts
     at .59s and runs .56s. The scroll delay is measured from the END of that,
     so the setting means "pause after it finishes", not "pause after submit". */
  var ANIM_MS = 1150;
  var SCROLL_MS = 1400;

  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  /* scrollIntoView gives no control over speed, and the page sets
     scroll-behavior:smooth globally, so the glide is driven by hand here and
     the CSS behaviour is suspended while it runs. */
  function glideTo(target, duration, isCancelled) {
    var root = document.documentElement;
    var previous = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';

    var start = window.pageYOffset;
    var end = start + target.getBoundingClientRect().top;
    var distance = end - start;
    var began = null;

    function step(now) {
      if (isCancelled()) { root.style.scrollBehavior = previous; return; }
      if (began === null) began = now;
      var progress = Math.min((now - began) / duration, 1);
      window.scrollTo(0, start + distance * easeInOutCubic(progress));
      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        root.style.scrollBehavior = previous;
      }
    }
    window.requestAnimationFrame(step);
  }

  function scrollOn(stack) {
    var delay = parseFloat(stack.dataset.scrollDelay);
    if (!delay || delay <= 0) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var target = document.getElementById('whatscoming');
    if (!target) return;

    var cancelled = false;
    var events = ['wheel', 'touchmove', 'keydown', 'pointerdown'];
    function cancel() {
      cancelled = true;
      events.forEach(function (ev) { window.removeEventListener(ev, cancel); });
    }
    function isCancelled() { return cancelled; }
    events.forEach(function (ev) { window.addEventListener(ev, cancel, { passive: true }); });

    window.setTimeout(function () {
      if (cancelled) return;
      events.forEach(function (ev) { window.removeEventListener(ev, cancel); });
      glideTo(target, SCROLL_MS, isCancelled);
    }, ANIM_MS + delay * 1000);
  }

  Array.prototype.forEach.call(stacks, function (stack) {
    var form = stack.querySelector('form');
    if (!form || stack.dataset.done === 'true') return;

    var key = stack.dataset.klaviyoKey;
    var list = stack.dataset.klaviyoList;
    var err = stack.querySelector('[data-err]');
    var phoneInput = stack.querySelector('[data-phone]');
    var ccSelect = stack.querySelector('[data-country-select]');
    var emailInput = form.querySelector('input[type="email"]');
    var btn = form.querySelector('button[type="submit"]');
    var label = btn ? btn.textContent : '';

    function fail(message) {
      if (btn) { btn.disabled = false; btn.textContent = label; }
      if (err) { err.textContent = message; err.hidden = false; }
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var email = emailInput ? emailInput.value.trim() : '';
      if (!email || email.indexOf('@') < 1 || email.indexOf('.') < 0) {
        fail('Enter a valid email address.');
        if (emailInput) emailInput.focus();
        return;
      }

      if (!key || !list) {
        fail('Signup is not configured yet. Try again shortly.');
        return;
      }

      var cc = ccSelect ? ccSelect.value : stack.dataset.country;
      var phone = phoneInput ? e164(phoneInput.value, cc) : '';
      if (phone && phone.replace(/\D/g, '').length < 10) {
        fail('That number does not look right. Check it, or leave it blank.');
        if (phoneInput) phoneInput.focus();
        return;
      }

      if (btn) { btn.disabled = true; btn.textContent = 'Joining\u2026'; }
      if (err) { err.hidden = true; err.textContent = ''; }

      var subs = { email: { marketing: { consent: 'SUBSCRIBED' } } };
      var attrs = { email: email };
      if (phone) {
        attrs.phone_number = phone;
        subs.sms = { marketing: { consent: 'SUBSCRIBED' } };
      }
      attrs.subscriptions = subs;

      /* Ad tracking: written to the profile so a buyer at Drop 01 can be
         traced back to the creative that brought them in. Empty values are
         left off so an organic signup is not stamped with blanks. */
      var eventId = newEventId();
      var props = { meta_event_id: eventId };
      TRACK_KEYS.forEach(function (k) {
        var v = tracked(k);
        if (v) props[k] = v;
      });
      attrs.properties = props;

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': REVISION },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: stack.dataset.source || 'LUKS waitlist',
              profile: { data: { type: 'profile', attributes: attrs } }
            },
            relationships: { list: { data: { type: 'list', id: list } } }
          }
        })
      })
        .then(function (r) {
          /* Klaviyo returns 202 Accepted on success, with an empty body. */
          if (r.status === 202 || r.ok) {
            confirmed(stack);
            publishLead(eventId);
            return;
          }
          if (phone && (r.status === 400 || r.status === 422)) {
            fail('That number was not accepted. Check it, or leave it blank.');
            return;
          }
          fail('That did not go through. Check the address and try again.');
        })
        .catch(function () {
          fail('That did not go through. Check your connection and try again.');
        });
    });
  });
})();